import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-primary" }, "News")
], -1)
const _hoisted_5 = {
  class: "col-md-10 overflow-auto",
  style: {"height":"120px"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("dl", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news, (article, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("dt", _hoisted_7, _toDisplayString(article.date), 1),
                _createElementVNode("dd", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: `/${article.type}_en`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.newstype[article.type].text), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _hoisted_9,
                  _createElementVNode("span", {
                    innerHTML: article.text
                  }, null, 8, _hoisted_10)
                ])
              ], 64))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}